import sanitizeHtml from "sanitize-html";
import { replacePlaceholders } from "../../common/placeholders";

export default class TinyMceService {
  /* @ngInject */
  constructor($rootScope, $filter, $timeout, ModalsManager, FilePicker, SweetAlertService, Utils, Notification) {
    this.$rootScope = $rootScope;
    this.$filter = $filter;
    this.$timeout = $timeout;
    this.ModalsManager = ModalsManager;
    this.FilePicker = FilePicker;
    this.SweetAlertService = SweetAlertService;
    this.Utils = Utils;
    this.NotificationService = Notification;
  }

  getConfig(quote) {
    return {
      setup: (editor) => {
        editor.on("init", (e) => {
          this.$timeout(() => this.SweetAlertService.close(), 1000);
          editor.setContent(replacePlaceholders(editor.getContent(), quote, quote.lastVersion, false, true));
        });
      },
      init_instance_callback: (editor) => {
        editor.on("click", (e) => {
          const tagClicked = e.target.nodeName;
          if (tagClicked === "TD") $(".mce-tinymce").css("display", "block");
        });
        editor.on("NodeChange", (e) => {
          const contentSelected = $("<div>" + tinymce.activeEditor.selection.getContent() + "</div>");
          if (e.element.attributes.placeholder) e.element.removeAttribute("placeholder");
          if (contentSelected.contents().length > 1 && !!contentSelected.find("img").length) this._hideToolbar();
        });
      },
      paste_postprocess: async (pl, o) => {
        o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;/gi, " ");
        this._checkPasteTableAndBrowser(o.node.innerHTML);
        if (o.node.innerHTML.match(/<img src="blob:/)) {
          const pastedContentWithBlob = o.node.innerHTML;
          o.node.innerHTML = "";
          this._pasteContentWithBlobImages(pastedContentWithBlob).then();
        } else {
          o.node.innerHTML = this.Utils.removeExternalSrcImgTags(o.node.innerHTML);
          o.node.innerHTML = sanitizeHtml(o.node.innerHTML, {
            allowedTags: ["h1", "h2", "em", "strong", "p", "img", "span"],
            allowedAttributes: { img: ["src"] },
            allowedSchemes: ["https"],
            allowProtocolRelative: false,
          });
        }
      },
      language_url: "/vendors/tiny-mce/langs/es.js",
      theme: "inlite",
      inline: true,
      language: this.$rootScope.organization.settings.appLanguage,
      plugins: [
        "lists link noneditable imagetools",
        "media table custompaste",
        "imagelibrary placeholdermodal medialauncher",
      ],
      external_plugins: {
        custompaste: "/vendors/tiny-mce/plugins/custompaste/plugin.min.js",
        imagelibrary: "/vendors/tiny-mce/plugins/image-library/image-library.js",
        placeholdermodal: "/vendors/tiny-mce/plugins/placeholder-modal/placeholder-modal.js",
        responsivetable: "/vendors/tiny-mce/plugins/responsive-table/responsive-table.js",
        linebreak: "/vendors/tiny-mce/plugins/line-break/line-break.js",
        medialauncher: "/vendors/tiny-mce/plugins/media-launcher/media-launcher.js",
      },
      selection_toolbar:
        "h1 h2 | alignleft aligncenter alignright | bold italic strikethrough | linebreak | bullist numlist | link | placeholdermodal",
      insert_toolbar: "imagelibrary responsivetable medialauncher",
      table_toolbar:
        "tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
      default_link_target: "_blank",
      link_title: false,
      anchor_bottom: false,
      anchor_top: false,
      typeahead_urls: false,
      target_list: [
        { title: this.$filter("trans")("tinyMCE.sameWindow"), value: "_self" },
        { title: this.$filter("trans")("tinyMCE.newWindow"), value: "_blank" },
      ],
      imagetools_cors_hosts: ["s3-eu-west-1.amazonaws.com", "cdn.filestackcontent.com"],
      imagetools_toolbar: "link",
      media_dimensions: false,
      media_poster: false,
      media_alt_source: false,
      media_live_embeds: true,
      browser_spellcheck: true,
      table_appearance_options: false,
      table_advtab: false,
      table_cell_advtab: false,
      table_row_advtab: false,
      table_resize_bars: true,
      paste_plaintext_inform: false,
      paste_auto_cleanup_on_paste: true,
      custompaste_allow_local_images: true,
      custompaste_word_import: "clean",
      custompaste_html_import: "clean",
      custompaste_block_drop: true,
      skin_url: "/vendors/tiny-mce/skins/proposal-software",
      invalid_elements:
        "code, quote, i, th, abbr, address, area, article, aside, audio, base, bdi, bdo, blockquote, button, canvas, caption, cite, col, colgroup, datalist, dd, del, details, dfn, dialog,dl, dt, embed, fiedlist, fieldcaption, figure, fonto, footer, form, frameset, header, frame, input, ins, kbd, keygen, label, legend, link, main, map, mark, menu, menuitem, meta, meter, nav, noscript, object, optgroup, option, output, param, picture, pre, progress, q, rp, rt, ruby, s, sam, script, section, select, small, source, strike, style, sub, summary, sup, textarea, time, title, track, tt, u, var, video, wbr",
      valid_classes: {
        table: "table-responsive",
        span: "mceNonEditable,custom-placeholder",
      },
      extended_valid_elements:
        "h1[placeholder|style],h2[placeholder|style],p[placeholder|style],span[class|style|title],iframe[src|allowfullscreen]",
      object_resizing: "img",
      entity_encoding: "raw",
      modals_manager: this.ModalsManager,
      trans_filter: this.$filter("trans"),
    };
  }

  _hideToolbar() {
    this.$timeout(() => {
      $(".mce-tinymce").each(function (index) {
        $(this).css("display", "none");
      });
    }, 30);
  }

  _checkPasteTableAndBrowser(pastedContent) {
    if (pastedContent.includes("<table") && pastedContent.includes("</table>") && !this.Utils.isBrowserChrome()) {
      this.NotificationService.warning({
        title: this.$filter("trans")("notificationService.title.remember"),
        message: this.$filter("trans")("notificationService.message.pasteTable"),
      });
    }
  }

  async _pasteContentWithBlobImages(pastedContentWithBlob) {
    for (const imgTag of $(`<div>${pastedContentWithBlob}</div>`).find("img")) {
      const blobUriFromImgSrc = $(imgTag).attr("src");
      const blobInfo = tinymce.activeEditor.editorUpload.blobCache.getByUri(blobUriFromImgSrc);
      const base64Metadata = blobInfo.blob();
      const base64Image = `data:${base64Metadata.type};base64,${blobInfo.base64()}`;

      if (base64Metadata.size > parseInt(process.env.FILESTACK_MAX_SIZE)) {
        pastedContentWithBlob = pastedContentWithBlob.replace(imgTag, "");
        this.SweetAlertService.failedPasteImageMaxSize();
      } else {
        this.SweetAlertService.pasteImageLoader();
        const imageMetadata = await this.FilePicker.uploadSectionBase64Image(base64Image);
        if (!imageMetadata) {
          pastedContentWithBlob = pastedContentWithBlob.replace(imgTag, "");
          this.SweetAlertService.failedPasteImageUpload();
        } else {
          pastedContentWithBlob = pastedContentWithBlob.replace(blobUriFromImgSrc, imageMetadata.url);
          this.$timeout(() => this.SweetAlertService.close(), 1000);
        }
      }
    }
    tinymce.activeEditor.execCommand("mceInsertContent", false, pastedContentWithBlob);
  }
}
